import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const home = () => {
        navigate("/");
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div>
            
            <div className="container px-3">
                <section className="faq-hero container p-4 p-lg-5 rounded-5 mt-5">
                    <h1>Privacy Policy</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="#" onClick={(e) => { e.preventDefault(); home(); }} style={{ cursor: 'pointer' }}>
                                    Home
                                </a>
                            </li>
                            <li className="breadcrumb-item active">Privacy Policy</li>
                        </ol>
                    </nav>
                </section>

                <div className="blog-wrapper mt-lg-5 pt-lg-5 mb-lg-5">
                    <main className="blogmargintop mb-5">
                        <div className="terms-conditions-content">
                            <h3 className="term-heading">
                                At ASRA Immigration Consulting Inc. ("ASRA Immigration," "we," "our," or "us"), 
                                we are committed to protecting your personal information and respecting your privacy. 
                                This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and services.
                            </h3>
                        </div>

                        <div className="terms-conditions-content mt-5">
                            <h3 className="term-heading">1. Information We Collect</h3>
                            <p className="term-desc">
                                We collect several types of information to provide and improve our services to you.
                            </p>
                            
                            <h4 className="post-heading mt-4">Personal Information:</h4>
                            <ul className="terms-list">
                                <li>Full name</li>
                                <li>Date of birth</li>
                                <li>Email address</li>
                                <li>Phone number</li>
                                <li>Address</li>
                                <li>Passport details</li>
                                <li>Education documents</li>
                                <li>Work history</li>
                                <li>Financial information (only if required for immigration forms)</li>
                            </ul>

                            <h4 className="post-heading mt-4">Website Usage Information:</h4>
                            <p className="term-desc">
                                Collected automatically:
                            </p>
                            <ul className="terms-list">
                                <li>IP address</li>
                                <li>Device details</li>
                                <li>Browser type</li>
                                <li>Pages visited</li>
                                <li>Cookies and tracking data</li>
                            </ul>

                            <h4 className="post-heading mt-4">Uploaded or Shared Documents:</h4>
                            <p className="term-desc">
                                Documents you provide:
                            </p>
                            <ul className="terms-list">
                                <li>Identity proof</li>
                                <li>Educational certificates</li>
                                <li>Work experience letters</li>
                                <li>Language test results</li>
                                <li>Government forms</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">2. How We Use Your Information</h3>
                            <p className="term-desc">
                                We use your data for:
                            </p>
                            <ul className="terms-list">
                                <li>Immigration assessment</li>
                                <li>Submitting forms to immigration authorities</li>
                                <li>Communication regarding your application</li>
                                <li>Verifying identity and documents</li>
                                <li>Payment processing</li>
                                <li>Improving website and service experience</li>
                                <li>Legal compliance</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">3. Sharing of Information</h3>
                            <p className="term-desc">
                                We may share information only with:
                            </p>
                            <ul className="terms-list">
                                <li>Immigration authorities (IRCC, USCIS, UKVI, etc.)</li>
                                <li>Educational Credential Assessment bodies (WES, IQAS, etc.)</li>
                                <li>Language testing centers (IELTS, PTE if required)</li>
                                <li>Payment processors</li>
                                <li>Authorized team members handling your case</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">4. Data Security</h3>
                            <p className="term-desc">
                                We take strong measures to protect your data:
                            </p>
                            <ul className="terms-list">
                                <li>Secure servers</li>
                                <li>Encrypted storage</li>
                                <li>Access control for staff</li>
                                <li>Regular risk assessments</li>
                            </ul>
                            <p className="term-desc">
                                However, no method is 100% secure. We strive to protect your data but cannot guarantee absolute security.
                            </p>

                            <h3 className="term-heading mt-lg-5">5. Cookies & Tracking</h3>
                            <p className="term-desc">
                                Our website may use cookies to:
                            </p>
                            <ul className="terms-list">
                                <li>Improve user experience</li>
                                <li>Remember preferences</li>
                                <li>Analyze website traffic</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">6. Your Rights</h3>
                            <p className="term-desc">
                                Depending on your location, you may have the right to:
                            </p>
                            <ul className="terms-list">
                                <li>Access your personal data</li>
                                <li>Update incorrect information</li>
                                <li>Request deletion (where legally allowed)</li>
                                <li>Withdraw consent</li>
                                <li>Request a copy of stored data</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">7. Data Retention</h3>
                            <p className="term-desc">
                                We retain your personal data only for:
                            </p>
                            <ul className="terms-list">
                                <li>The duration of your immigration process</li>
                                <li>Additional time required by law</li>
                                <li>Internal record-keeping purposes</li>
                            </ul>

                            <h3 className="term-heading mt-lg-5">8. Third-Party Links</h3>
                            <p className="term-desc">
                                Our website may include links to external sites. We are not responsible for their privacy practices or content.
                            </p>

                            <h3 className="term-heading mt-lg-5">9. Minors</h3>
                            <p className="term-desc">
                                We do not intentionally collect information from individuals under 18 unless part of a family application.
                                Parents/guardians must provide consent.
                            </p>

                            <h3 className="term-heading mt-lg-5">10. Changes to This Policy</h3>
                            <p className="term-desc">
                                We may update this policy at any time. The "Last Updated" date at the top will reflect changes.
                                Continued use of our website or services means you accept the updated policy.
                            </p>

                            <h3 className="term-heading mt-lg-5">11. Contact Information</h3>
                            <ul className="terms-list contact-info">
                                <li><strong>Address:</strong> 323 Sweetclover Way, Ottawa, ON, K4A 1E6</li>
                                <li><strong>Phone:</strong> +1-613-209-9539</li>
                                <li><strong>Email:</strong> info@asraimmigration.ca</li>
                                <li><strong>Website:</strong> asraimmigration.ca</li>
                            </ul>
                        </div>
                    </main>
                </div>
            </div>
            
        </div>
    );
}

export default PrivacyPolicy;